import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import I18n, { Translate } from 'i18n'
import Loader from 'components/Loader'
import AppCaptcha from 'components/AppCaptcha'
import SectionHeader from 'components/SectionHeader'
import AppFooter from 'components/AppFooter'
import * as routePaths from 'constants/routePaths'
import './style.css'


export default class EmailSubscriptionForm extends Component {
    static propTypes = {
        fetchSendEmailShoppingList: PropTypes.func.isRequired,
        setEmailAddress: PropTypes.func.isRequired,
        emailAddress: PropTypes.string.isRequired,
        errorMessage: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        status: PropTypes.string.isRequired
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.status === 'loading' && nextProps.status === 'submitted') {
            this.props.history.push(routePaths.LIST)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.fetchSendEmailShoppingList()
    }

    handleChange = (e) => {
        this.props.setEmailAddress(e.target.value)
    }

    render() {
        if (this.props.isLoading) {
            return <Loader />
        }

        return (
            <form className='form content'>
                <div className='content'>
                    <SectionHeader>
                        <p className='form-text'><Translate value='sendEmailDescription' /></p>

                        <input
                            className='form__input'
                            type='email'
                            name='email'
                            value={this.props.emailAddress}
                            placeholder={I18n.t('email')}
                            onChange={this.handleChange}
                        />
                    </SectionHeader>

                    <AppCaptcha />

                    { this.props.errorMessage &&
                        <p className='form-text form-text_type_error'>{this.props.errorMessage}</p>
                    }
                </div>

                <AppFooter>
                    <button
                        className={`button button_type_primary button_type_wide form__button ${!this.props.emailAddress ? 'button_type_disabled' : ''}`}
                        type='submit'
                        onClick={this.handleSubmit}>
                        <Translate value='send' />
                    </button>

                    <Link
                        to={routePaths.LIST}
                        className='button button_type_secondary button_icon_left'>
                        <span className='icon icon-left'></span>
                        <Translate value='backToList' />
                    </Link>
                </AppFooter>
            </form>
        )
    }
}
